
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'


export default {
directives: {
TransferDom
},
components: {
XHeader,
Group,
CellBox,
Popup,
InlineLoading
},
data () {
return {
place: 'disneyland',
waitTime: null,
attractionShow: false,
attractionId: '',
attractionData: null,
currentAttractionItem: null,
titles: {
disneyland: 'Disney Land',
disneysea: 'Disney Sea',
usj: '环球影城'
}
};
},
created () {
const place = this.$route.params.place.toLowerCase();
this.place = Object.keys(this.titles).indexOf(place) === -1 ? 'disneyland' : place;
this.loadData();
},
computed: {
pageTitle () {
return this.titles[this.place];
}
},
methods: {
loadData () {
const self = this;
self.waitTime = null;
self.$vux.loading.show({ text: 'Loading' });
self.$http.get('./static/phpapi/waittime.php', {params: {place: self.place}})
.then((resp) => {
self.waitTime = resp.data.waittime;
})
.catch((err) => console.error(err))
.then(() => self.$vux.loading.hide());
},
loadAttraction () {
const self = this;
self.attractionData = null;
self.$http.get('./static/phpapi/attraction.php', {params: {place: self.place, attraction: self.attractionId}})
.then((resp) => {
self.attractionData = resp.data.data;
})
.catch((err) => console.error(err));
},
handleAttraction (item) {
if (item.key) {
this.currentAttractionItem = item;
this.attractionId = item.key.toLowerCase();
this.attractionShow = true;
this.loadAttraction();
}
}
}
};



// WEBPACK FOOTER //
// ./src/components/queue/WaitTime.vue